import { render, staticRenderFns } from "./ReferralsList.vue?vue&type=template&id=4b8383e5"
import script from "./ReferralsList.vue?vue&type=script&lang=js"
export * from "./ReferralsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports